import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetBoardLikesResponse } from "../../api/board_likes";

export type TApiBoardDetailResult = {
  result?: GetBoardLikesResponse;
};

export const fetchBoardLikes = async (root_id: number ,like_type: number): Promise<TApiResult & TApiBoardDetailResult> => {
  const query = {
    query :  { root_id, like_type }
  }; 

  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .board_likes.get({ ...query, ...authHeader })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchBoardLikes");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
